import React from 'react';
import { Column, Row, JsonBlock } from '@ydistri/ds';
import { styled } from 'styled-components';
import { useTemplateOrCalculation } from '../../../../hooks/useTemplateOrCalculation';
import LoadingIndicator from '../../../../components/global/LoadingIndicator/LoadingIndicator';
import { useGetCustomExportRunItemDetailQuery } from '../apiCalculationExport';
import { formatCustomExportJson } from '../customExportLib';
import CustomExportStatusBadge from './CustomExportStatusBadge';

const DetailTitle = styled.div`
  margin-bottom: 0.5rem;
  font-weight: 600;
`;

interface CustomExportRunItemDetailProps {
  customExportRunId: number;
  customExportRunItemId: number;
}

const CustomExportRunItemDetail: React.FC<CustomExportRunItemDetailProps> = ({
  customExportRunId,
  customExportRunItemId,
}) => {
  const templateOrCalculation = useTemplateOrCalculation();
  const { data, isFetching, isError } = useGetCustomExportRunItemDetailQuery({
    calculationId: templateOrCalculation.id,
    customExportRunId,
    customExportRunItemId,
  });

  if (isFetching && !data) {
    return (
      <Column $padding={1}>
        <LoadingIndicator />
      </Column>
    );
  }

  if (isError) {
    return (
      <Column $padding={1}>
        <div>Failed to load custom export item detail.</div>
      </Column>
    );
  }

  if (!data) {
    return (
      <Column $padding={1}>
        <div>Custom export item detail is not available.</div>
      </Column>
    );
  }

  return (
    <Column $padding={1} $gap="1rem">
      <Row $gap="0.75rem" $alignItems="center">
        <strong>Item #{data.id}</strong>
        <CustomExportStatusBadge status={data.status} />
      </Row>
      <div>
        <DetailTitle>Request data</DetailTitle>
        <JsonBlock>
          {formatCustomExportJson(data.requestData, 'No request data available.')}
        </JsonBlock>
      </div>
      <div>
        <DetailTitle>Response data</DetailTitle>
        <JsonBlock>
          {formatCustomExportJson(data.responseData, 'No response data available.')}
        </JsonBlock>
      </div>
    </Column>
  );
};

export default CustomExportRunItemDetail;
